import { get } from 'lodash';

import { ModalTypeIds } from './constants';
import {
    checkRefineProcedureConstraint,
    checkUrgentCareConstraint,
    checkObgynConstraint,
    checkPediatricConstraint,
    checkNaturopathicConstraint,
    checkCrossListedConstraint,
    checkMayChargeAdditionalCopayConstraint,
    checkPhysicianAssistantConstraint,
} from './checkConstraintsHelper';

/*

Order of constraint priorities:

RefineProcedure
Pediatric
UrgentCare
Obgyn
PhysicianAssistant
Naturopath
Crosslisted
Assistant
AdditionalCopay

*/

export default function checkConstraints({
    isProfile,
    obgynProcedures,
    orthopedicProcedures,
    provider,
    searchProcedureId,
    searchSpecialtyId,
}) {
    const params = {
        isProfile,
        obgynProcedures,
        orthopedicProcedures,
        provider,
        providerIsUrgentCare: get(provider, 'practice.isUrgentCare'),
        providerRelevantSpecialtyId: get(provider, 'relevantSpecialty.id'),
        providerMayChargeAdditionalCopay: get(provider, 'mayChargeAdditionalCopay'),
        providerOnlySeesChildren: get(provider, 'onlySeesChildren'),
        providerProcedures: get(provider, 'procedures'),
        providerSpecialties: get(provider, 'specialties'),
        searchProcedureId,
        searchSpecialtyId,
    };

    const checkFunctions = [
        {
            checkFunction: checkRefineProcedureConstraint,
            modalType: ModalTypeIds.REFINE_PROCEDURE,
        },
        {
            checkFunction: checkPediatricConstraint,
            modalType: ModalTypeIds.PEDIATRIC,
        },
        {
            checkFunction: checkUrgentCareConstraint,
            modalType: ModalTypeIds.URGENT_CARE,
        },
        {
            checkFunction: checkObgynConstraint,
            modalType: ModalTypeIds.OBGYN,
        },
        {
            checkFunction: checkPhysicianAssistantConstraint,
            modalType: ModalTypeIds.PHYSICIAN_ASSISTANT,
        },
        {
            checkFunction: checkNaturopathicConstraint,
            modalType: ModalTypeIds.NATUROPATHIC,
        },
        {
            checkFunction: checkCrossListedConstraint,
            modalType: ModalTypeIds.CROSS_LISTED,
        },
        {
            checkFunction: checkMayChargeAdditionalCopayConstraint,
            modalType: ModalTypeIds.ADDITIONAL_COPAY,
        },
    ];

    for (let i = 0; i < checkFunctions.length; ++i) {
        const { checkFunction, modalType } = checkFunctions[i];

        if (checkFunction(params)) {
            return modalType;
        }
    }
}
